// Dependencies
import React from "react";

// Material UI Components
import Drawer from "@mui/material/Drawer";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import DialogTitle from "@mui/material/DialogTitle";

// Components
import CloseButton from "components/buttons/CloseButton/CloseButton.component";

// Styles
import { useStyles } from "./FilterDrawer.styles";

const FilterDrawer = ({
  open,
  handleClose,
  title,
  contents,
  actionMenuContents,
}) => {
  const classes = useStyles();

  return (
    <Drawer
      className={classes.drawer}
      anchor="bottom"
      classes={{
        paper: classes.drawerPaper,
      }}
      transitionDuration={{ enter: 250, exit: 250 }}
      open={open}
      onClose={handleClose}
      ModalProps={{
        keepMounted: true,
      }}
    >
      <DialogTitle>
        <span className={classes.absolute}>
          <CloseButton onClick={handleClose} />
        </span>
        <Typography gutterBottom className={classes.alignCenter} variant="h3">
          {title}
        </Typography>
      </DialogTitle>
      <div className={classes.drawerBody} key="filter-modal-mobile-part">
        {contents}
      </div>
      <DialogActions className={classes.drawerActions}>
        {actionMenuContents}
      </DialogActions>
    </Drawer>
  );
};

export default FilterDrawer;
